(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1249],{

/***/ 38366:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ CategoriesProducts; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(59499);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(67294);
/* harmony import */ var _styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(28833);
/* harmony import */ var _styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _components_CategoriesAside_CategoriesAside__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6551);
/* harmony import */ var _components_CategoriesBanner_CategoriesBanner__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11848);
/* harmony import */ var _components_CategoriesSelect_CategoriesSelect__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(16723);
/* harmony import */ var _components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92536);
/* harmony import */ var _components_DeliveryBanner_DeliveryBanner__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(54196);
/* harmony import */ var _components_FavoritesAside_FavoritesAside__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(79255);
/* harmony import */ var _components_Footer_Footer__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31875);
/* harmony import */ var _components_Header_Header__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(3266);
/* harmony import */ var _components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(86894);
/* harmony import */ var _components_ProductsMenu_ProductMenu__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(5903);
/* harmony import */ var _store_cart__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(88362);
/* harmony import */ var _store_categories__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(9266);
/* harmony import */ var _store_deliveryMode__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(34525);
/* harmony import */ var _store_productsCollection__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(67713);
/* harmony import */ var _store_productsSort__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(43660);
/* harmony import */ var _utils_bannerOptions__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(76962);
/* harmony import */ var _utils_getBreadcrumb__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(65269);
/* harmony import */ var _utils_products__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(1003);
/* harmony import */ var _products_products_module_scss__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(22097);
/* harmony import */ var _products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(85893);




/* Components */













/* Controllers */






/* Styles */







var __N_SSG = true;
function CategoriesProducts(_ref) {
  var banners = _ref.banners,
      footerLinks = _ref.footerLinks,
      navigation = _ref.navigation,
      offers = _ref.offers,
      canonical = _ref.canonical,
      category = _ref.category,
      subCategory = _ref.subCategory,
      staticProducts = _ref.staticProducts,
      meta = _ref.meta,
      categoriesFromFile = _ref.categoriesFromFile;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(''),
      deliveryMode = _useState[0],
      setDeliveryMode = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(0),
      numOfProducts = _useState2[0],
      setNumOfProducts = _useState2[1];

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(_utils_bannerOptions__WEBPACK_IMPORTED_MODULE_18__/* ["default"].catalog */ .Z.catalog),
      showBySelection = _useState3[0],
      setShowBySelection = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(false),
      isCartVisible = _useState4[0],
      setIsCartVisible = _useState4[1];

  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      productCollections = _useState5[0],
      setProductCollections = _useState5[1];

  var _useState6 = (0,react__WEBPACK_IMPORTED_MODULE_2__.useState)(),
      categories = _useState6[0],
      setCategories = _useState6[1];

  var slug = router.query.slug;

  var _isOffersPage = (0,_utils_products__WEBPACK_IMPORTED_MODULE_20__/* .isOffersPage */ .NP)(slug);

  var _isSecondLevelPage = (0,_utils_products__WEBPACK_IMPORTED_MODULE_20__/* .isSecondLevelPage */ .PQ)(slug);

  var categoryName = category === null || category === void 0 ? void 0 : category.name;
  var subCategoryName = subCategory === null || subCategory === void 0 ? void 0 : subCategory.name;
  var breadcrumbData = [{
    url: "".concat("https://kritikos-sm.gr", "/categories/").concat(slug[0], "/"),
    name: slug[0]
  }, {
    url: "".concat("https://kritikos-sm.gr", "/").concat(canonical, "/"),
    name: slug[1]
  }];
  var breadcrumb = (0,_utils_getBreadcrumb__WEBPACK_IMPORTED_MODULE_19__/* .createBreadcrumbJson */ .El)(breadcrumbData);
  (0,react__WEBPACK_IMPORTED_MODULE_2__.useEffect)(function () {
    var subscriptionDeliveryMode = _store_deliveryMode__WEBPACK_IMPORTED_MODULE_15__/* ["default"].subscribe */ .Z.subscribe(setDeliveryMode);
    var productCollections$ = _store_productsCollection__WEBPACK_IMPORTED_MODULE_16__/* ["default"].subscribe */ .Z.subscribe(setProductCollections);
    var isCartVisible$ = _store_cart__WEBPACK_IMPORTED_MODULE_13__/* ["default"].getIsVisble$ */ .ZP.getIsVisble$().subscribe(setIsCartVisible);
    var sortBy$ = _store_productsSort__WEBPACK_IMPORTED_MODULE_17__/* ["default"].subscribe */ .Z.subscribe(setShowBySelection);
    var categories$ = _store_categories__WEBPACK_IMPORTED_MODULE_14__/* ["default"].subscribe */ .Z.subscribe(setCategories);
    return function () {
      sortBy$.unsubscribe();
      isCartVisible$.unsubscribe();
      productCollections$.unsubscribe();
      subscriptionDeliveryMode.unsubscribe();
      categories$.unsubscribe();
    };
  }, []);
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.Fragment, {
    children: [slug.length > 1 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("script", {
      type: "application/ld+json",
      dangerouslySetInnerHTML: {
        __html: JSON.stringify(breadcrumb)
      }
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_CustomMetaHead__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
      meta: meta
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
      className: (_styles_pages_index_module_scss__WEBPACK_IMPORTED_MODULE_22___default().headerContainer),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_Header_Header__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {
        navigation: navigation,
        isEnabled: true
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_Navigation_Navigation__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
      navigation: navigation
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_DeliveryBanner_DeliveryBanner__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_CategoriesSelect_CategoriesSelect__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
      slug: slug
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("main", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().main), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z)({}, (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().spaceOpenCart), isCartVisible)),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
        className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().mainLeft), (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().listBanner)]),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
          className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().sticky)]),
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_CategoriesBanner_CategoriesBanner__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
            onChangeOrderBy: function onChangeOrderBy(e) {
              return _store_productsSort__WEBPACK_IMPORTED_MODULE_17__/* ["default"].update */ .Z.update(e.target.value);
            },
            showBySelection: showBySelection,
            numOfProducts: numOfProducts,
            categoryName: categoryName,
            subCategoryName: subCategoryName,
            slug: slug
          })
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("section", {
          className: (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().mainContent),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
            className: (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().hideOnSmallScreen),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsxs)("div", {
              className: classnames__WEBPACK_IMPORTED_MODULE_0___default()([(_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().sticky), (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().categoriesAsideTop), (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().categoriesAsideProductDetails)]),
              children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_FavoritesAside_FavoritesAside__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {}), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_CategoriesAside_CategoriesAside__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                categoriesFromFile: categoriesFromFile,
                slug: slug,
                category: category
              })]
            })
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)("div", {
            className: (_products_products_module_scss__WEBPACK_IMPORTED_MODULE_23___default().productScrollingContainer),
            children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_ProductsMenu_ProductMenu__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
              isSecondLevelPage: _isSecondLevelPage,
              isOfferListPage: _isOffersPage,
              categories: categories,
              category: category,
              subCategory: subCategory,
              productCollections: productCollections,
              slug: slug,
              setNumOfProducts: setNumOfProducts,
              deliveryMode: deliveryMode,
              offers: offers,
              banners: banners,
              showBySelection: showBySelection,
              staticProducts: staticProducts
            })
          })]
        })]
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_21__.jsx)(_components_Footer_Footer__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
      footerLinks: footerLinks
    })]
  });
}

/***/ }),

/***/ 65269:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CH": function() { return /* binding */ getBreadcrumbValidation; },
/* harmony export */   "El": function() { return /* binding */ createBreadcrumbJson; },
/* harmony export */   "aY": function() { return /* binding */ getBreadcrumbStepProduct; },
/* harmony export */   "xk": function() { return /* binding */ getBreadcrumbTwoStep; }
/* harmony export */ });
/* harmony import */ var _home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(27812);

function createBreadcrumbJson(list) {
  var breadcrumb = list.map(function (value, index) {
    return {
      '@type': 'ListItem',
      position: index + 1,
      name: value.name,
      item: value.url
    };
  });
  var json = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: breadcrumb
  };
  return json;
}
function getBreadcrumbStepProduct(slug, index) {
  var step = slug.slice(0, index + 1).join('/');

  if (index === slug.length - 1) {
    return {
      url: "".concat("https://kritikos-sm.gr", "/products/").concat(step, "/"),
      name: slug[index].split('-')[0]
    };
  }

  return {
    url: "".concat("https://kritikos-sm.gr", "/categories/").concat(step, "/"),
    name: slug[index]
  };
}
function getBreadcrumbValidation(data) {
  if (data.length === 4) {
    return [].concat((0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.slice(0, 2)), (0,_home_runner_work_Wave_Grocery_Kritikos_Web_Wave_Grocery_Kritikos_Web_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(data.slice(3)));
  }

  return data;
}
function getBreadcrumbTwoStep(link) {
  var firstStep = link.split('/')[0];
  return [{
    url: "".concat("https://kritikos-sm.gr", "/").concat(firstStep, "/"),
    name: firstStep
  }, {
    url: "".concat("https://kritikos-sm.gr", "/").concat(link, "/"),
    name: link.split('/')[1]
  }];
}
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  createBreadcrumbJson: createBreadcrumbJson,
  getBreadcrumbStepProduct: getBreadcrumbStepProduct,
  getBreadcrumbTwoStep: getBreadcrumbTwoStep,
  getBreadcrumbValidation: getBreadcrumbValidation
});

/***/ }),

/***/ 78052:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/categories/[...slug]",
      function () {
        return __webpack_require__(38366);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 22097:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"main":"products_main__TtvX6","mainLeft":"products_mainLeft__Zq_Pd","listContainer":"products_listContainer___Yoas","listBanner":"products_listBanner__Vqeci","mainContent":"products_mainContent__SRXIi","defaultContainer":"products_defaultContainer__XTPoZ","listBannerSearch":"products_listBannerSearch__xE6mU","listSearch":"products_listSearch__oQH6E","mainList":"products_mainList__SPxdH","sticky":"products_sticky__gf_n1","categoriesAsideProductDetails":"products_categoriesAsideProductDetails__b9XMz","spaceOpenCart":"products_spaceOpenCart__StTkZ","categoriesAsideTop":"products_categoriesAsideTop__9uz0r","productsListContainer":"products_productsListContainer__IY8_d","offerListContainer":"products_offerListContainer__7kkh6","offerListWrapper":"products_offerListWrapper__CzhiT","productScrollingContainer":"products_productScrollingContainer__1CZkB","hideOnSmallScreen":"products_hideOnSmallScreen__gR_BI"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5937,9866,1228,4617,5445,3609,260,2013,3253,3996,4843,6864,9950,7730,9878,3231,9579,9774,2888,179], function() { return __webpack_exec__(78052); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);